<template>
  <div class="bg-[#f9f8f6]">
    <Container>
      <FadeIn> 
        <div class="py-12 lg:py-16">
          <h1 
          id="main-title" 
          :class="[
            content.title.length > 58 ? 
            'md:mt-8 text-center text-2xl leading-[1.25] sm:text-3xl sm:leading-[1.2] md:text-4xl md:leading-[1.17] font-bold tracking-tight text-gray-900 lora' :
            'md:mt-8 text-center text-3xl leading-[1.25] sm:text-4xl sm:leading-[1.2] md:text-5xl md:leading-[1.12] font-bold tracking-tight text-gray-900 lora'
          ]">
            {{ content.title }}
          </h1>
          <div 
          v-if="content.subtitle" 
          class="text-subtitle lg:max-w-[650px] text-center mx-auto" 
          v-interpolation 
          v-html="content.subtitle">
          </div>
          <div 
          v-if="content.cta?.length > 0"
          class="mt-4 lg:mt-8 flex items-center gap-x-6 justify-center lg:justify-start">
            <ElementButton
            v-for="(cta, index) in content.cta"
            :key="'cta-'+index"
            :url="cta.cta_id.url" 
            :type="cta.cta_id.type"
            :size="cta.cta_id.size"
            :arrow="cta.cta_id.arrow"
            :index="index"
            >
              {{ cta.cta_id.title }}
            </ElementButton>
          </div>
        </div>

        <div class="max-w-[1200px] mx-auto hidden md:inline-block">
          <ImageResponsive
          v-if="heroBImage"
          :data="heroBImage"
          :lazy="true"
          :xs="12"
          :sm="12"
          :md="10"
          :lg="10"
          :xl="10"
          classes="rounded"
          />
        </div>
        <div class="max-w-[1200px] mx-auto md:hidden">
          <ImageResponsive
          v-if="heroBImageMob"
          :data="heroBImageMob"
          :lazy="true"
          :xs="12"
          :sm="12"
          :md="10"
          :lg="10"
          :xl="10"
          classes="rounded"
          />
        </div>

      </FadeIn>
    </Container>
  </div>

</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

const heroBImage = {
  id: '5cf77f18-b238-4111-8977-34090cbdf10f',
  filename_download: 'elker-hero-b.png',
  width: 4492,
  height: 2397,
  description: 'Elker Anonymous reporting for the early detection of workplace issues',
}

const heroBImageMob = {
  id: '8bfe0869-ac16-4d49-9575-6311ca7f8470',
  filename_download: 'elker-hero-b-mobile.png',
  width: 1516,
  height: 1333,
  description: 'Elker Anonymous reporting for the early detection of workplace issues',
}
</script>